import React from 'react';
import { Tooltip } from 'react-tooltip';
import { StatCardProps } from '../types';

export const StatCard: React.FC<StatCardProps> = ({ label, value, overdue, isLoading = false, tooltip }) => {
    const tooltipId = `stat-card-${label.replace(/\s+/g, '-').toLowerCase()}`;
    return (
        <div className={`cap-stat-card ${overdue ? 'cap-stat-card--overdue' : ''} ${isLoading ? 'cap-stat-card--loading' : ''}`}>
            <div className="cap-stat-card__label-row">
                <span className="cap-stat-card__label">{label}</span>
                {tooltip && (
                    <>
                        <span
                            className="cap-stat-card__tooltip-icon"
                            data-tooltip-id={tooltipId}
                        >
                            ?
                        </span>
                        <Tooltip
                            id={tooltipId}
                            className="cap-stat-card__tooltip"
                            place="top"
                        >
                            <div style={{ maxWidth: '250px', fontSize: '12px', lineHeight: '1.5' }}>
                                {tooltip}
                            </div>
                        </Tooltip>
                    </>
                )}
            </div>

            {!overdue ? (<hr className="cap-stat-card__divider" />) : <hr className="cap-stat-card--overdue__divider" />}
            <div className="cap-stat-card__value-row">
                {isLoading ? (
                    <span className="cap-stat-card__skeleton" />
                ) : (
                    <>
                        <span className="cap-stat-card__value" style={{ color: overdue ? '#E53935' : '#1a1a2e' }}>
                            {value}
                        </span>
                        {overdue && <div style={{ display: 'flex', alignItems: 'center' }}>
                            <i
                                className="pi pi-info-circle"
                                style={{
                                    position: 'absolute',
                                    fontSize: '30px',
                                    color: '#C0392B',
                                    backgroundColor: '#FADBD8',
                                    borderRadius: '50%',
                                    padding: '4px',
                                }}
                            />
                        </div>}
                    </>
                )}
            </div>
        </div>
    );
};